export type AuthProviderType = 'descope' | 'openid' | 'local';
export const DEFAULT_AUTH_PROVIDER: AuthProviderType = 'descope';
export const LOCAL_DEFAULT_TENANT_ID = 'local-tenant';
export const LOCAL_DEFAULT_TENANT_NAME = 'Local Tenant';
export const DESCOPE_JWT_TYPE_ACCESS_KEY = 'access_key';
export const AUTH_CONTEXT_TOKEN_TYPE_USER = 'user';
export const AUTH_CONTEXT_TOKEN_TYPE_ACCESS_KEY = DESCOPE_JWT_TYPE_ACCESS_KEY;
export type AuthContextTokenType =
  | typeof AUTH_CONTEXT_TOKEN_TYPE_USER
  | typeof AUTH_CONTEXT_TOKEN_TYPE_ACCESS_KEY;
export type JWTTokenPayload = {
  sub?: string | null;
  type?: typeof DESCOPE_JWT_TYPE_ACCESS_KEY;
  dct?: string | null;
  email?: string | null;
  tenantDomain?: string | null;
  selfProvisionDomains?: string[] | null;
  roles?: string[] | null;
  permissions?: string[] | null;
  byoc?: boolean | null;
};
